import Label, { LABEL_SIZES } from "@shared/ui/Label";
import React from "react";
import { TabsComponentPropsType, TabType } from "Tabs";

const PillTabs = ({
  tabs,
  onTabChange,
  className = "",
}: TabsComponentPropsType) => (
  <div className={`flex items-center gap-md flex-wrap ${className || ""}`}>
    {tabs.map(({ id, icon, label, rightContent, isActive }: TabType) => (
      <button
        key={id}
        className={`group inline-flex items-center h-8 border-0 outline-0 cursor-pointer px-sm py-0 ${
          isActive ? "bg-brand-lightest rounded" : "bg-transparent"
        }`}
        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          event.stopPropagation();
          onTabChange(id);
        }}
      >
        {icon && (
          <div
            className={`mr-2xs inline-flex w-lg h-lg shrink-0 items-center justify-center ${
              isActive
                ? "text-primary"
                : "text-tertiary group-hover:text-secondary"
            }`}
          >
            {icon}
          </div>
        )}

        <Label
          size={LABEL_SIZES.SMALL}
          color={
            isActive
              ? "text-primary"
              : "text-tertiary group-hover:text-secondary"
          }
          className="leading-none"
        >
          {label}
        </Label>

        {rightContent && <div className="ml-2xs">{rightContent}</div>}
      </button>
    ))}
  </div>
);

export default PillTabs;
